import React, { useEffect, useState } from 'react'
import { SecondSectionCss } from './Dashboard.style';
import api from '../../../api/Apis';
import apiPaths from '../../../services/apPaths';
import { useNavigate } from 'react-router-dom';

function SecondSection() {
    const [productDetails, setProductDetails] = useState();
    useEffect(() => {
        api.getAllProduct('us').then((res) => {
            if (res?.data?.code === 1) {
                setProductDetails(res?.data);
            }
        })
    }, [])

    const CommissionArray = [
        { price: 11.99, }, { price: 7.99, }, { price: 21.99, }, { price: 11.99 },
    ];
    const CommissionArrayNew = [
        { price: 5.99, }, { price: 3.99, }, { price: 10.99, }, { price: 5.99 },
    ];

    const navigate = useNavigate();
    return (
        <SecondSectionCss>
            <div className="container">

                <div className="cstm-row">
                    <div className="left-img-sec">
                        <h2 className='mobile'>AFFILIATE PROGRAM HIGHLIGHTS</h2>


                        <div className="right-img-sec mobile">
                            <div className='affiliate-highlights'>
                                <div className='benefits-section'>
                                    <h5 className='benefits-include'>
                                        Benefits include:
                                    </h5>
                                    <div className='benefits-list'>
                                        <ul>
                                            <li>
                                                As a Kaire affiliate, you'll earn a generous 20% commission on the first order of every customer you refer and 10% commission on any further orders that customer purchases! *
                                            </li>
                                            <li>A 90-day cookie period (referral window)</li>
                                            <li>Monthly special offers and promotions</li>
                                            <li>Trusted, high-quality consumable products
                                                for over 30+ years</li>
                                            <li>Convenient doorstep delivery</li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className='earn-commission-image'>
                            <img className='first_img' src="/images/journey-2.jpg" alt="Image" />
                            <img src="/images/earncommission.png" alt="Image" className='earn-commission' />
                        </div>
                    </div>
                    <div className="right-img-sec">
                        <div className="text-content desktop">
                            <h2>AFFILIATE PROGRAM HIGHLIGHTS</h2>
                            <img src='/images/groupproducts.png' />
                        </div>
                        <div className='affiliate-highlights desktop'>
                            <div className='benefits-section'>
                                <h5 className='benefits-include'>
                                    Benefits include:
                                </h5>
                                <div className='benefits-list'>
                                    <ul>
                                        <li>As a Kaire affiliate, you'll earn a generous 20% commission on the first order of every customer you refer and 10% commission on any further orders that customer purchases! *</li>
                                        <li>A 90-day cookie period (referral window)</li>
                                        <li>Monthly special offers and promotions</li>
                                        <li>Trusted, high-quality consumable products
                                            for over 30+ years</li>
                                        <li>Convenient doorstep delivery</li>
                                        <li>No monthly commitment</li>
                                        <li>No yearly renewals</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='become-an-affiliate'>
                            <h4>Ready to jump on board?</h4>
                            <p>Apply to become an AFFILIATE through the
                                AFFILIATE Link button below.</p>

                            <button type="button" className="signup-btnn" onClick={() => navigate("/signup")}>SIGN ME UP!</button>
                        </div>
                    </div>
                </div>
                <div className="demonstrate-commission desktop">
                    <div className="right-img-sec mobile">
                        <div className='become-an-affiliate'>
                            <h4>Ready to jump on board?</h4>
                            <p>Apply to become an AFFILIATE through the
                                AFFILIATE Link button below.</p>

                            <button type="button" className="signup-btnn" onClick={() => navigate("/signup")}>SIGN ME UP!</button>
                        </div>
                    </div>
                    <h4>These examples demonstrate the 20% commission you can earn on the first order of every customer you refer*</h4>
                    <div className='product-details'>
                        {productDetails?.products?.map((row, productIndex) => {
                            return (
                                <div className='all-product-images' key={productIndex}>
                                    <p>{row?.name}</p>
                                    <div className='product-refer'>
                                        <img src={`${apiPaths?.DOC_URL}${row?.product_images[0]?.image}`} height="180" width="200" alt={row?.name} />
                                        <div className='amount-sec'>
                                            <p>YOU GET</p>
                                            {CommissionArray?.[productIndex]?.price && (
                                                <h5>${CommissionArray[productIndex]?.price}</h5>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                    </div>

                    <h4 className='h4' style={{ marginTop: "30px" }}>These examples demonstrate the 10% commission you can earn on any further orders that your customer purchases after their initial first order.</h4>
                    <div className='product-details'>
                        {productDetails?.products?.map((row, productIndex) => {
                            return (
                                <div className='all-product-images' key={productIndex}>
                                    <p>{row?.name}</p>
                                    <div className='product-refer'>
                                        <img src={`${apiPaths?.DOC_URL}${row?.product_images[0]?.image}`} height="180" width="200" alt={row?.name} />
                                        <div className='amount-sec'>
                                            <p>YOU GET</p>
                                            {CommissionArrayNew?.[productIndex]?.price && (
                                                <h5>${CommissionArrayNew[productIndex]?.price}</h5>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <p className='single_div' style={{ textAlign: "center" }}>* Based on the one-time order price with no discounts.</p>
                </div>
            </div>


            <div className="demonstrate-commission mobile">
                <div className='container'>
                    <div className="right-img-sec mobile">
                        <div className='become-an-affiliate'>
                            <h4 className=''>Ready to jump on board?</h4>
                            <p>Apply to become an AFFILIATE through the
                                AFFILIATE Link button below.</p>

                            <button type="button" className="signup-btnn" onClick={() => navigate("/signup")}>SIGN ME UP!</button>
                        </div>
                    </div>
                    <h4 className='h4'>These examples demonstrate the $20% commission you can earn on the first order of every customer you refer*</h4>
                    <div className='product-details'>
                        {productDetails?.products?.map((row, productIndex) => {
                            return (
                                <div className='all-product-images' key={productIndex}>
                                    <p>{row?.name}</p>
                                    <div className='product-refer'>
                                        <img src={`${apiPaths?.DOC_URL}${row?.product_images[0]?.image}`} height="180" width="200" alt={row?.name} />
                                        <div className='amount-sec'>
                                            <p>YOU GET</p>
                                            {CommissionArray?.[productIndex]?.price && (
                                                <h5>{CommissionArray[productIndex]?.price}</h5>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <p className='single_div' style={{ textAlign: "center" }}>* Based on the one-time order price with no discounts.</p>
                </div>
            </div>
        </SecondSectionCss>
    )
}
export default SecondSection;
